<template>
  <div class="exchange-bg" @click.stop>
    <img class="close-icon" src="~/assets/imgs/search_del.png" @click="close" />
    <div class="title">信息确认</div>
    <div class="content">{{ props.detail.name }}</div>
    <div class="price">
      <div>兑换价格</div>
      <div v-if="props.detail.paymentType === 'lecoin'" class="price-right">
        <span>{{ props.detail.price }}</span
        >乐币
      </div>
      <div v-else-if="props.detail.paymentType === 'mobile_integral'" class="price-right">
        <span>{{ props.detail.price }}</span
        >积分
      </div>
      <div v-else-if="props.detail.paymentType === 'member_free'" class="price-right">会员免费</div>
      <div v-else class="price-right">免费</div>
    </div>
    <div class="count" v-if="props.detail.buyNumLimit !== 1">
      <div>购买数量</div>
      <div class="count-right">
        <img src="~/assets/imgs/subtract.png" @click="count > 1 ? count-- : (count = count)" />
        <span>{{ count }}</span>
        <img src="~/assets/imgs/add.png" v-if="count < props.detail.buyNumLimit" @click="count++" />
        <img src="~/assets/imgs/noadd.png" v-else />
      </div>
    </div>
    <div class="btn">
      <div v-if="props.detail.paymentType === 'lecoin'">
        <span style="color: #000">合计：</span>
        <span
          ><span class="price-big">{{ props.detail.price * count }}</span
          >乐币</span
        >
      </div>
      <div v-else-if="props.detail.paymentType === 'mobile_integral'">
        <span style="color: #000">合计：</span>
        <span
          ><span class="price-big">{{ props.detail.price * count }}</span
          >积分</span
        >
      </div>
      <div v-else-if="props.detail.paymentType === 'member_free'">会员免费</div>
      <div v-else>免费</div>
      <div class="confirm" @click="exChangeNow">立即兑换</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { defineEmits, defineProps } from "vue";
import { exchangeGoods } from "~/business/alova/methods/goodsPageApi.ts";
import { useRequest } from "alova";
import { pandora } from "~/utils/index";

const emit = defineEmits([
  "close",
  "lecoinnull",
  "integralnull",
  "failPrice",
  "phone",
  "exchangeRes"
]);
const props = defineProps<{
  detail: {};
}>();
const count = ref(1);
const changeShow = ref(false);
onMounted(() => {
  changeShow.value = true;
});
/**
 * @description 关闭弹窗
 * @return {void}
 */
const close = () => {
  emit("close", count.value);
};
/**
 * @description 立即兑换
 * @return {void}
 */
const exChangeNow = () => {
  pandora(
    "event_goods_shop_detail_exchange_confirm_click",
    "福利商店商品详情页：兑换确认按钮点击",
    {
      merchandise_id: sessionStorage.getItem("commodityId") || "",
      merchandise_name: props.detail.name,
      status: props.detail.status,
      exchange_type: props.detail.paymentType,
      exchange_cost: props.detail.price && props.detail.price * count.value,
      exchange_num: count.value
    }
  );
  // 如果是乐币判断是否足够支付;
  if (
    props.detail.paymentType === "lecoin" &&
    props.detail.balance < props.detail.price * count.value
  ) {
    close();
    emit("lecoinnull", props.detail.price * count.value);
  } else if (
    props.detail.paymentType === "mobile_integral" &&
    props.detail.balance < props.detail.price * count.value
  ) {
    close();
    emit("integralnull");
  } else {

    const { onSuccess ,onError} = useRequest(()=>{return exchangeGoods({ num: count.value })})
    onSuccess((res)=>{
      if(res?.data?.code === 200){
        if (props.detail.paymentType === "mobile_integral") {
          const mobileOrderNo = res?.data?.data?.orderNo;
          const cmccMobile = res?.data?.data?.cmccMobile;
          // getverificationcodefun();
          emit("phone", { mobileOrderNo, cmccMobile });
          close();
        } else {
          // getprizesuccess(data);
          emit("exchangeRes", res?.data?.data);
          close();
        }
      }else{
        close();
        emit("failPrice", res?.data?.code, res?.data);
      }
    })
    onError((err)=>{
      emit("failPrice", err?.data?.code, err?.data);
      close();
    })
  }
};
</script>
<style scoped lang="scss">
.exchange-bg {
  width: 100%;
  background: #fff;
  position: relative;
  padding: 0.27rem 0 0 0;

  .close-icon {
    position: absolute;
    right: 0.6rem;
    top: 0.6rem;
    width: 1.03rem;
    height: 1.03rem;
  }

  .title {
    font-size: 0.682rem;
    font-weight: 600;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
  }

  .content {
    font-size: 0.682rem;
    padding: 0.85rem 0.425rem;
    border-bottom: 0.341rem solid #f5f5f5;
  }

  .count {
    display: flex;
    font-size: 0.597rem;
    padding: 0.5rem 1rem;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1.5rem solid #f5f5f5;

    .count-right {
      display: flex;
      align-items: center;

      img {
        height: 1.02rem;
        width: 1.02rem;
      }

      span {
        margin: 0 0.5rem;
      }
    }
  }

  .price {
    font-size: 0.597rem;
    padding: 0.5rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    .price-right {
      color: #ff7210;

      span {
        font-weight: 700;
        font-size: 1rem;
      }
    }
  }

  .btn {
    height: 2.81rem;
    color: #ff7210;
    font-size: 0.597rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;

    .confirm {
      font-size: 0.682rem;
      font-weight: 600;
      height: 1.79rem;
      line-height: 1.68rem;
      width: 5.12rem;
      background: #ff7210;
      color: #fff;
      text-align: center;
      border-radius: 1rem;
    }

    .price-big {
      font-weight: 700;
      font-size: 1rem;
    }
  }
}
</style>
